module.exports = __webpack_public_path__ + "img/icon-check-active-survey.876c5537.svg";